module.exports = __webpack_public_path__ + "static/media/icon_mindfullness.cc720ba8.svg";